export default "__VITE_ASSET__D_7qzOZ1__"